export const environment = {
  production: true,
  //api: 'http://172.16.0.13:3004',
  api: 'https://etgfirenzecloud.com:3030/smartpga',
  apiAWS: 'https://api.etgfirenze.com/smartpga',
  version: 'v.2.5.0.1',
  networksWithNotification: ['MARCHE']
  // api: 'http://tlc02:3000'
};
